// extracted by mini-css-extract-plugin
module.exports = {"Container":"DateSelector_Container__3C0KC","Label":"DateSelector_Label__2rlgM","Icon":"DateSelector_Icon__2_bH_"};